import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import NotificationSettingsLayout from '../components/NotificationSettingsLayout';

import NotificationSettingsPage from './NotificationSettingsPage';

const NotificationSettings = () => (
  <NotificationSettingsLayout
    title="Notification Settings"
    indexLabel="Notification Preferences"
    breadCrumbsList={getSettingBreadCrumbList(
      ISettingBreadCrumbTypes.ACCOUNT,
      Pages['NOTIFICATION_SETTINGS']
    )}
  >
    <NotificationSettingsPage />
  </NotificationSettingsLayout>
);

export default NotificationSettings;
